export const GOOGLE_MAPS_API_KEY = "AIzaSyD0CH7-cvnp8TfPYD_tSgoGv3SP2kCUWyQ";
